import axios from "../../../core/services/axiosConfig";
import { useState, useEffect, useRef } from "react"
import Select from 'react-select';
import './AddConditionsForm.css';
import { useSelector } from "react-redux"
import { toast } from "react-hot-toast";

function formatDateTimeLocalToApi(dt: string) {
    if (!dt) return "";
    const [date, time] = dt.split("T");
    if (!date || !time) return "";
    const [yyyy, mm, dd] = date.split("-");
    return `${dd}/${mm}/${yyyy} ${time.length === 5 ? time + ':00' : time}`;
}
function formatApiToDateTimeLocal(api: string) {
    // api: DD/MM/YYYY HH:mm:ss -> YYYY-MM-DDTHH:mm
    if (!api) return "";
    const [date, time] = api.split(" ");
    if (!date || !time) return "";
    const [dd, mm, yyyy] = date.split("/");
    return `${yyyy}-${mm}-${dd}T${time.slice(0, 5)}`;
}

const initialState = {
    promoCode: "",
    promoDescription: "",
    totalCoupons: "",
    maxCouponsPerCustomer: "",
    activationTime: "",
    expiryTime: "",
    onlyForNewUser: "",
    isEnabled: "",
    isVisible: "",
    device: "web",
    discountType: "",
    discountValue: "",
    discountCap: "",
    conditionType: "",
    couponDescription: "",
    promoId: "",
    couponsRemaining: ""
}

interface PromoCodeListFormProps {
    mode?: "create" | "update";
    initialData?: any;
}

const PromoCodeListForm = ({ mode = "create", initialData }: PromoCodeListFormProps) => {

    let { user } = useSelector((s: any) => s.authStore);
    const [form, setForm] = useState(initialState)
    const [errors, setErrors] = useState<any>({})
    const [loading, setLoading] = useState(false)
    const [apiError, setApiError] = useState("")
    const [conditions, setConditions] = useState<any[]>([]) //noneOFconditions
    const [noneOfConditions, setNoneOfConditions] = useState<any[]>([]) //noneOFconditions
    const [noneOfCondAttributeList, setNoneOfCondAttributeList] = useState<any[]>([]) //noneOFconditions
    const [actions, setActions] = useState<any[]>([])
    const [condCategoryType, setCondCategoryType] = useState("")
    const [condAttributeType, setCondAttributeType] = useState("")
    const [condAttributeList, setCondAttributeList] = useState<any[]>([])
    const [actCategoryType, setActCategoryType] = useState("")
    const [actAttributeType, setActAttributeType] = useState("")
    const [actAttributeValue, setActAttributeValue] = useState("")
    const [actAttributeList, setActAttributeList] = useState<any[]>([])
    const DISCOUNT_CAP_REF = useRef<any>(null);
    const FREE_SHIPPING_REF = useRef<any>(null);
    const DISCOUNT_TYPE_REF = useRef<any>(null);
    const DISCOUNT_VALUE_REF = useRef<any>(null);
    const USER_REF = useRef<any>(null);
    const CART_REF = useRef<any>(null);
    const BRAND_ALL_OF_REF = useRef<any>(null);
    const BRAND_NONE_OF_REF = useRef<any>(null);
    const PRODUCT_ALL_OF_REF = useRef<any>(null);
    const PRODUCT_NONE_OF_REF = useRef<any>(null);
    const CATEGORY_ALL_OF_REF = useRef<any>(null);
    const CATEGORY_NONE_OF_REF = useRef<any>(null);
    const PAYMENT_REF = useRef<any>(null);
    const PAYMENT_ALL_OF_REF = useRef<any>(null);
    const PAYMENT_NONE_OF_REF = useRef<any>(null);

    // Populate form if initialData is provided (update mode)
    useEffect(() => {
        if (mode === "update" && initialData) {
            const attr = initialData.promoAttributes || {};
            setForm({
                ...initialState,
                promoId: attr.promoId || "",
                promoCode: attr.promoCode || "",
                promoDescription: attr.promoDescription || "",
                totalCoupons: attr.totalCoupons?.toString() || "",
                couponsRemaining: attr.couponsRemaining?.toString() || "",
                maxCouponsPerCustomer: attr.maxCouponsPerCustomer?.toString() || "",
                activationTime: formatApiToDateTimeLocal(attr.activationTime),
                expiryTime: formatApiToDateTimeLocal(attr.expiryTime),
                onlyForNewUser: String(attr.onlyForNewUser),
                isEnabled: String(attr.isEnabled),
                isVisible: String(attr.isVisible),
                device: attr.device || "web"
            });
            // Populate conditions and actions
            setConditions(
                (initialData.conditionsList && initialData.conditionsList[0]?.criteriaList) || []
            );
            setNoneOfConditions(
                (initialData.conditionsList && initialData.conditionsList[1]?.criteriaList) || []
            );
            setActions(
                (initialData.actionsList && initialData.actionsList.criteriaList) || []
            );
        }
    }, [mode, initialData]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        setForm({ ...form, [e.target.name]: e.target.value })
        setErrors({ ...errors, [e.target.name]: undefined })
    }


    const validate = () => {
        const newErrors: any = {}
        if (!form.promoCode) newErrors.promoCode = "Coupon Name is required"
        if (!form.promoDescription) newErrors.promoDescription = "Description is required"
        if (!form.totalCoupons || isNaN(Number(form.totalCoupons))) newErrors.totalCoupons = "Total Coupons must be a number"
        if (!form.maxCouponsPerCustomer || isNaN(Number(form.maxCouponsPerCustomer))) newErrors.maxCouponsPerCustomer = "Max Coupons/User must be a number"
        if (!form.activationTime) newErrors.activationTime = "Activation Time is required"
        if (!form.expiryTime) newErrors.expiryTime = "Expiry Time is required"
        if (!form.onlyForNewUser) newErrors.onlyForNewUser = "Valid for new User is required"
        if (!form.isEnabled) newErrors.isEnabled = "Active is required"
        if (!form.isVisible) newErrors.isVisible = "Is Visible is required"
        if (!form.device) newErrors.device = "Device is required"
        if ([...conditions,...noneOfConditions].length === 0) newErrors.conditions = "At least one condition is required"
        if (actions.length === 0) newErrors.actions = "At least one action is required"
        return newErrors
    }

    // --- Condition logic ---
    const handleAddCondAttribute = (condAttributeType1:any,condAttributeValue1:any,evaluationType?:any) => {

        if (condAttributeType1 && condAttributeValue1) {
            setCondAttributeList((prevList) => [
                ...prevList,
                {
                    attributeType: condAttributeType1,
                    attributeValues: [...condAttributeValue1.split(',').map((str:any) => str.trim())],
                },
            ])
        }
    }

    const handleAddNoneOfCondAttribute = (condAttributeType1:any,condAttributeValue1:any) => {

        if (condAttributeType1 && condAttributeValue1) {
            setNoneOfCondAttributeList((prevList) => [
                ...prevList,
                {
                    attributeType: condAttributeType1,
                    attributeValues: [...condAttributeValue1.split(',').map((str:any) => str.trim())],
                },
            ]);
        }
    }

    const handleAddNonoOfCondition = () => {
        if (condCategoryType && noneOfCondAttributeList.length > 0) {
            setNoneOfConditions([
                ...noneOfConditions,
                {
                    categoryType: condCategoryType,
                    attributeList: noneOfCondAttributeList
                }
            ])
            setCondCategoryType("")
            setNoneOfCondAttributeList([])
        }
    }

    useEffect(() => {
        if (noneOfCondAttributeList.length > 0) {
            handleAddNonoOfCondition();
        }
    }, [noneOfCondAttributeList]);


    const handleAddCondition = () => {
        if (condCategoryType && condAttributeList.length > 0) {
            setConditions([
                ...conditions,
                {
                    categoryType: condCategoryType,
                    attributeList: condAttributeList
                }
            ])
            setCondCategoryType("")
            setCondAttributeList([])
        }
    }

    useEffect(() => {
        if (condAttributeList.length > 0) {
            handleAddCondition();
        }
    }, [condAttributeList]);


    useEffect(() => {
        if (actAttributeList.length > 0) {
            handleAddAction();
        }
    }, [actAttributeList]);

    const handleRemoveAllOfCondition = (idx: number) => {
        const updatedConditions = conditions.filter((_, i) => i !== idx);
        setConditions(updatedConditions);
    };

    const handleRemoveNoneOfCondition = (idx: number) => {
        const updatedNoneOfConditions = noneOfConditions.filter((_, i) => i !== idx);
        setNoneOfConditions(updatedNoneOfConditions);
    };



    // --- Action logic ---
    const handleAddActAttribute = (actAttributeType1:any,actAttributeValue1:any) => {
        if (actAttributeType1 && actAttributeValue1) {
            setActAttributeList((prevList) => [
            ...prevList,
            {
                attributeType: actAttributeType1,
                attributeValues: [actAttributeValue1],
            },
            ]);
            setActAttributeType("")
            setActAttributeValue("")
        }
    }
    const handleAddAction = () => {

        if (actCategoryType && actAttributeList.length > 0) {
            setActions([
                ...actions,

                {
                    categoryType: actCategoryType,
                    attributeList: actAttributeList
                }
            ])
            setActCategoryType("")
            setActAttributeList([])
        }
    }
    const handleRemoveAction = (idx: number) => {
        setActions(actions.filter((_, i) => i !== idx))
    }

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        setApiError("")
        const validationErrors = validate()
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors)
            return
        }
        setLoading(true)
        try {
            const payload = {
                promoAttributes: {
                    promoId: mode === "update" ? form.promoId : undefined,
                    promoCode: form.promoCode,
                    promoDescription: form.promoDescription,
                    totalCoupons: form.totalCoupons,
                    couponsRemaining: form.couponsRemaining,
                    maxCouponsPerCustomer: form.maxCouponsPerCustomer,
                    activationTime: formatDateTimeLocalToApi(form.activationTime),
                    expiryTime: formatDateTimeLocalToApi(form.expiryTime),
                    onlyForNewUser: form.onlyForNewUser,
                    isEnabled: form.isEnabled,
                    isVisible: form.isVisible,
                    device: form.device
                },
                conditionsList: [
                    {
                        evaluationType: "ALL_OF",
                        criteriaList: conditions
                    },
                      ...(noneOfConditions.length > 0
                    ? [
                        {
                        evaluationType: "NONE_OF",
                        criteriaList: noneOfConditions
                        }
                    ]
                    : [])
                ],
                actionsList: {
                    criteriaList: actions
                },
                userId: user?.id,
                userName:user?.email
            };

            const apiUrl = mode === "update"
                ? `${process.env.REACT_APP_CMS_SERVICE}/cmsApi/v1/promocode/update`
                : `${process.env.REACT_APP_CMS_SERVICE}/cmsApi/v1/promocode/create`;
            const res = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            })
            const responseJson = await res.json();
            if (responseJson.statusCode !== 200) throw new Error(mode === "update" ? responseJson.data : responseJson.data)
            mode === "update" ? toast.success("Coupon updated successfully!") : toast.success("Coupon created successfully!")
            if (mode === "create") {
                setForm(initialState)
                setConditions([])
                setNoneOfConditions([])
                setActions([])
                setErrors({})
            }
        } catch (err: any) {
            setApiError(err.message || "Unknown error")
        } finally {
            setLoading(false)
        }
    }


    const [selectedAttribute, setSelectedAttribute] = useState<any>('Cart');

    // Using a different name for the state variable

    const [categories, setCategories] = useState<any[]>([]);
    const [brands, setBrands] = useState<any[]>([]);


    useEffect(()=>{
        getBrand()
    },[])

    const getBrand = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_CMS_SERVICE}/cmsApi/v1/promocode/getbrands`);
            const formattedBrands = response.data.data.map((brand: any) => ({
                value: brand.idBrand,
                label: brand.brandName,
            }));
            setBrands(formattedBrands);
        } catch (error) {
            console.error("Error fetching brands:", error);
        } finally {
            setLoading(false);
        }
    };

    const customStyles = {
        control: (provided:any) => ({
            ...provided,
            minHeight: '40px',
        }),
    };

    useEffect(()=>{
        getAllCategories()
    },[])

    const getAllCategories = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_CMS_SERVICE}/cmsApi/v1/promocode/getcategories`);
            const formattedCategories = response.data.data.map((cat: any) => ({
                value: cat.categoryCode,
                label: cat.categoryName,
            }));
            setCategories(formattedCategories);
        } catch (error) {
            console.error("Error fetching categories:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="p-4">
                <div className="w-full bg-white shadow-[0_1px_4px_rgba(0,0,0,.2)] rounded mb-5">
                    <p className="bg-[#f6f8f8] p-4 text-base  border-b border-b-[#efeff4]">Basic Information</p>
                    <div className="py-4 px-2.5">
                        <form >
                            {/* PromoId and Coupons Remaining (read-only in update mode) */}
                            {mode === "update" && (
                                <div className="flex w-full mb-6 last:mb-0">
                                    <div className="w-1/2 px-2">
                                        <label className="block text-xs mb-1.5 text-[#5E5D5D] font-medium">Promo ID:</label>
                                        <input className="w-full h-9 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-sm font-light bg-gray-100" type="text" value={form.promoId} readOnly />
                                    </div>
                                    <div className="w-1/2 px-2">
                                        <label className="block text-xs mb-1.5 text-[#5E5D5D] font-medium">Coupons Remaining:</label>
                                        <input className="w-full h-9 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-sm font-light bg-gray-100" type="text" value={form.couponsRemaining} readOnly />
                                    </div>
                                </div>
                            )}
                            <div className="flex w-full mb-6 last:mb-0">
                                <div className="w-1/2 px-2">
                                    <label className="block text-xs mb-1.5 text-[#5E5D5D] font-medium">Coupon Name:</label>
                                    <input className="w-full h-9 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-sm font-light"
                                        type="text"
                                        name="promoCode"
                                        value={form.promoCode}
                                        onChange={handleChange}
                                        disabled={mode === "update"}
                                    />
                                    {errors.promoCode && <div className="text-xs text-red-500 mt-1">{errors.promoCode}</div>}
                                </div>
                                <div className="w-1/2 px-2">
                                    <label className="block text-xs mb-1.5 text-[#5E5D5D] font-medium">Total Coupons:</label>
                                    <input className="w-full h-9 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-XS font-light"
                                        type="text"
                                        name="totalCoupons"
                                        value={form.totalCoupons}
                                        onChange={handleChange}
                                    />
                                    {errors.totalCoupons && <div className="text-xs text-red-500 mt-1">{errors.totalCoupons}</div>}
                                </div>
                            </div>
                            <div className="flex w-full mb-6 last:mb-0">
                                <div className="w-1/2 px-2">
                                    <label className="block text-xs mb-1.5 text-[#5E5D5D] font-medium">Activation Time:</label>
                                    <input className="w-full h-9 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-sm font-light"
                                        type="datetime-local"
                                        name="activationTime"
                                        value={form.activationTime}
                                        onChange={handleChange}
                                    />
                                    {errors.activationTime && <div className="text-xs text-red-500 mt-1">{errors.activationTime}</div>}
                                </div>
                                <div className="w-1/2 px-2">
                                    <label className="block text-xs mb-1.5 text-[#5E5D5D] font-medium">Expiry Time:</label>
                                    <input className="w-full h-9 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-XS font-light"
                                        type="datetime-local"
                                        name="expiryTime"
                                        value={form.expiryTime}
                                        onChange={handleChange}
                                    />
                                    {errors.expiryTime && <div className="text-xs text-red-500 mt-1">{errors.expiryTime}</div>}
                                </div>
                            </div>
                            <div className="flex w-full mb-6 last:mb-0">
                                <div className="w-1/2 px-2">
                                    <label className="block text-xs mb-1.5 text-[#5E5D5D] font-medium">Max. Coupons Per User:</label>
                                    <input className="w-full h-9 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-sm font-light"
                                        type="text"
                                        name="maxCouponsPerCustomer"
                                        value={form.maxCouponsPerCustomer}
                                        onChange={handleChange}
                                    />
                                    {errors.maxCouponsPerCustomer && <div className="text-xs text-red-500 mt-1">{errors.maxCouponsPerCustomer}</div>}
                                </div>
                                <div className="w-1/2 px-2">
                                    <label className="block text-xs mb-1.5 text-[#5E5D5D] font-medium">Valid for new User:</label>
                                    <select className="bg-white text-xs border text-[#5E5D5D]  border-[#EAEAEA] h-9 px-3 rounded w-full" name="onlyForNewUser" value={form.onlyForNewUser} onChange={handleChange}>
                                        <option value="">Select</option>
                                        <option value="true">True</option>
                                        <option value="false">False</option>
                                    </select>
                                    {errors.onlyForNewUser && <div className="text-xs text-red-500 mt-1">{errors.onlyForNewUser}</div>}
                                </div>
                            </div>
                            <div className="flex w-full mb-6 last:mb-0">
                                <div className="w-1/2 px-2">
                                    <label className="block text-xs mb-1.5 text-[#5E5D5D] font-medium">Active:</label>
                                    <select className="bg-white text-xs border text-[#5E5D5D]  border-[#EAEAEA] h-9 px-3 rounded w-full" name="isEnabled" value={form.isEnabled} onChange={handleChange}>
                                        <option value="">Select</option>
                                        <option value="true">True</option>
                                        <option value="false">False</option>
                                    </select>
                                    {errors.isEnabled && <div className="text-xs text-red-500 mt-1">{errors.isEnabled}</div>}
                                </div>
                                <div className="w-1/2 px-2">
                                    <label className="block text-xs mb-1.5 text-[#5E5D5D] font-medium">Is Visible:</label>
                                    <select className="bg-white text-xs border text-[#5E5D5D]  border-[#EAEAEA] h-9 px-3 rounded w-full" name="isVisible" value={form.isVisible} onChange={handleChange}>
                                        <option value="">Select</option>
                                        <option value="true">True</option>
                                        <option value="false">False</option>
                                    </select>
                                    {errors.isVisible && <div className="text-xs text-red-500 mt-1">{errors.isVisible}</div>}
                                </div>
                            </div>
                            <div className="flex w-full mb-6 last:mb-0">
                                <div className="w-1/2 px-2">
                                    <label className="block text-xs mb-1.5 text-[#5E5D5D] font-medium">Select Device type:</label>
                                    <select className="bg-white text-xs border text-[#5E5D5D]  border-[#EAEAEA] h-9 px-3 rounded w-full" name="device" value={form.device} onChange={handleChange}>
                                        <option value="web">Web</option>
                                        <option value="app">App</option>
                                        <option value="app_exclusive">App Exclusive</option>
                                        <option value="all">All</option>
                                    </select>
                                    {errors.device && <div className="text-xs text-red-500 mt-1">{errors.device}</div>}
                                </div>
                                <div className="w-1/2 px-2">
                                    <label className="block text-xs mb-1.5 text-[#5E5D5D] font-medium">Coupon Description:</label>
                                    <input className="w-full h-9 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light"
                                        type="text"
                                        name="promoDescription"
                                        value={form.promoDescription}
                                        onChange={handleChange}
                                    />
                                    {errors.promoDescription && <div className="text-xs text-red-500 mt-1">{errors.promoDescription}</div>}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                {/* Add Action List */}
                <div className="flex w-full justify-between">
                    <div className="w-1/2 bg-white  shadow-[0_1px_4px_rgba(0,0,0,.2)] rounded mb-5 mr-2">
                        <p className="bg-[#f6f8f8] p-4 text-base  border-b border-b-[#efeff4]">  {mode === "create" ? "Add" : "Update"}  Action List</p>
                        <div className="flex w-full flex-wrap px-2 mb-6 last:mb-0">
                            {true && (
                                <div className="w-full px-2 mt-4">
                                    <label className="block text-xs mb-1.5 text-[#5E5D5D] font-medium">Category Type</label>
                                    <select className="bg-white text-xs border text-[#5E5D5D]  border-[#EAEAEA] h-9 px-3 rounded w-full" name="device" value={actCategoryType} onChange={e => setActCategoryType(e.target.value)} >
                                        <option value="">SELECT</option>
                                        <option value="MAX_DISCOUNT">Discount Cap</option>
                                        <option value="SHIPPING">Shipping</option>
                                        <option value="DISCOUNT">Discount</option>
                                    </select>
                                    {/* <input className="w-full h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light mb-2" value={actCategoryType} onChange={e => setActCategoryType(e.target.value)} placeholder="e.g. SHIPPING" /> */}
                                    {actCategoryType === "MAX_DISCOUNT" && (
                                        <>
                                            <div className="flex mt-2 mb-2">
                                                <input className="w-1/2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light mr-2" value="DISCOUNT_CAP" placeholder="Attribute Type (e.g. FREE_SHIPPING)" readOnly />
                                                <input className="w-1/2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light"  ref = {DISCOUNT_CAP_REF}   placeholder="Attribute Value (e.g. true)" />
                                            </div>
                                            <button type="button" className="bg-blue-500 text-white px-4 rounded h-8 mt-2" onClick={()=>{handleAddActAttribute('DISCOUNT_CAP',DISCOUNT_CAP_REF?.current?.value || '');}}>Add</button>
                                        </>
                                    )}
                                    {actCategoryType === "SHIPPING" && (
                                        <>
                                            <div className="flex mt-2 mb-2">
                                                <input className="w-1/2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light mr-2" value="FREE_SHIPPING"  placeholder="Attribute Type (e.g. FREE_SHIPPING)" readOnly />

                                                {/* <input className="w-1/2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light" ref = {FREE_SHIPPING_REF}  placeholder="Attribute Value (e.g. true)" /> */}
                                                <select className="bg-white text-xs border text-[#5E5D5D]  border-[#EAEAEA] h-9 px-3 rounded w-full" name="device" ref = {FREE_SHIPPING_REF}  >
                                                    <option value="">SELECT</option>
                                                    <option value="true">TRUE</option>
                                                    <option value="false">FALSE</option>
                                                </select>
                                            </div>
                                            <button type="button" className="bg-blue-500 text-white px-4 rounded h-8 mt-2" onClick={()=>{handleAddActAttribute('FREE_SHIPPING',FREE_SHIPPING_REF?.current?.value || '');}}>Add</button>
                                        </>
                                    )}
                                    {actCategoryType === "DISCOUNT" && (

                                        <>
                                            <div className="flex mt-2 mb-2">
                                                <input className="w-1/2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light mr-2" value="DISCOUNT_TYPE" onChange={e => setActAttributeType('DISCOUNT_TYPE')} placeholder="Attribute Type (e.g. FREE_SHIPPING)" readOnly />
                                                {/* <input className="w-1/2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light" ref = {DISCOUNT_TYPE_REF}  placeholder="Attribute Value (e.g. true)" /> */}
                                                <select className="bg-white text-xs border text-[#5E5D5D]  border-[#EAEAEA] h-9 px-3 rounded w-full" name="device" ref = {DISCOUNT_TYPE_REF}  >
                                                    <option value="">SELECT</option>
                                                    <option value="PERCENTAGE">PERCENTAGE</option>
                                                    <option value="FIXED">FIXED</option>
                                                </select>
                                            </div>

                                            <div className="flex mt-2 mb-2">
                                                <input className="w-1/2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light mr-2" value="DISCOUNT_VALUE" onChange={e => setActAttributeType('DISCOUNT_VALUE')} placeholder="Attribute Type (e.g. FREE_SHIPPING)" readOnly />
                                                <input className="w-1/2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light" ref = {DISCOUNT_VALUE_REF}  placeholder="Attribute Value (e.g. true)" />
                                                {/* <button type="button" className="bg-blue-500 text-white px-4 rounded h-8 mt-2" onClick={()=>{handleAddActAttribute('DISCOUNT_VALUE',DISCOUNT_VALUE_REF?.current?.value || '');}}>Add</button> */}
                                            </div>
                                            <button type="button" className="bg-blue-500 text-white px-4 rounded h-8 mt-2" onClick={()=>{handleAddActAttribute("DISCOUNT_TYPE",DISCOUNT_TYPE_REF?.current?.value || '');handleAddActAttribute('DISCOUNT_VALUE',DISCOUNT_VALUE_REF?.current?.value || '');}}>Add</button>
                                        </>

                                    )}
                                </div>
                            )}
                        </div>
                        <div className="px-2">
                            {actions.length > 0 && actions.map((action, idx) => (
                                <div key={idx} className="flex items-center justify-between bg-gray-100 rounded px-2 py-1 mb-1">
                                    <span className="text-xs">
                                        {action.categoryType}
                                        {/* - {action.attributeList.map((a: any) => `${a.attributeType}: ${a.attributeValues.join(",")}`).join(" | ")} */}
                                        <div className="mt-1">
                                        {action.attributeList.map((a: any, i: number) => {
                                            if (action.categoryType === "MAX_DISCOUNT") {
                                                return (
                                                    <div key={i} className="flex mb-1 gap-2">
                                                    {/* Input for attributeType */}
                                                    <input
                                                        type="text"
                                                        value={a.attributeType}
                                                        className="w-1/2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light"
                                                        readOnly
                                                    />

                                                    {/* Input for attributeValues (comma separated) */}
                                                    <input
                                                        type="text"
                                                        value={a.attributeValues.join(",")}
                                                        onChange={(e) => {
                                                        const updated = [...actions];
                                                        updated[idx].attributeList[i].attributeValues = e.target.value
                                                            .split(",")
                                                            .map((v) => v.trim());
                                                        setActions(updated);
                                                        }}
                                                        className="w-1/2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light"
                                                    />
                                                    </div>
                                                );
                                            }

                                            if (action.categoryType === "SHIPPING") {
                                                return (
                                                    <div key={i} className="flex mb-1 gap-2">
                                                    {/* Input for attributeType */}
                                                    <input
                                                        type="text"
                                                        value={a.attributeType}
                                                        className="w-1/2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light"
                                                        readOnly
                                                    />

                                                    {/* Input for attributeValues (comma separated) */}
                                                    <select className="bg-white text-xs border text-[#5E5D5D] border-[#EAEAEA] h-9 px-3 rounded w-full" name="device" value={a.attributeValues}
                                                        onChange={(e) => {
                                                            const updated = [...actions];
                                                            updated[idx].attributeList[i].attributeValues = e.target.value
                                                                .split(",")
                                                                .map((v) => v.trim());
                                                            setActions(updated);
                                                        }}>
                                                        <option value="true">TRUE</option>
                                                        <option value="False">FALSE</option>
                                                    </select>
                                                    </div>
                                                );
                                            }

                                            if (action.categoryType === "DISCOUNT") {
                                                return (
                                                    <div key={i}>
                                                        <div className="flex mb-2">
                                                            {
                                                                a.attributeType === "DISCOUNT_TYPE" && (
                                                                    <>
                                                                        <input
                                                                            className="w-1/2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light mr-2"
                                                                            value={a.attributeType}
                                                                            placeholder="Attribute Type"
                                                                            readOnly
                                                                        />
                                                                        <select className="bg-white text-xs border text-[#5E5D5D] border-[#EAEAEA] h-9 px-3 rounded w-full" name="device" value={a.attributeValues}
                                                                            onChange={(e) => {
                                                                                const updated = [...actions];
                                                                                updated[idx].attributeList[i].attributeValues = e.target.value
                                                                                    .split(",")
                                                                                    .map((v) => v.trim());
                                                                                setActions(updated);
                                                                            }}>
                                                                            <option value="PERCENTAGE">PERCENTAGE</option>
                                                                            <option value="FIXED">FIXED</option>
                                                                        </select>
                                                                    </>
                                                                )
                                                            }
                                                        </div>

                                                        <div className="flex mb-2">
                                                            {
                                                                a.attributeType === "DISCOUNT_VALUE" && (
                                                                    <>
                                                                        <input
                                                                            className="w-1/2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light mr-2"

                                                                            value={a.attributeType}
                                                                            placeholder="Attribute Value (e.g. true)"
                                                                        />
                                                                        <input
                                                                            className="w-1/2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light"
                                                                            value={a.attributeValues.join(",")}
                                                                            onChange={(e) => {
                                                                                const updated = [...actions];
                                                                                updated[idx].attributeList[i].attributeValues = e.target.value
                                                                                    .split(",")
                                                                                    .map((v) => v.trim());
                                                                                setActions(updated);
                                                                            }}
                                                                            placeholder="Attribute Value"
                                                                        />
                                                                    </>
                                                                )
                                                            }
                                                        </div>

                                                    </div>
                                                );
                                            }

                                        return null; // default fallback
                                    })}
                                    </div>

                                        </span>
                                    <button type="button" className="text-red-500 text-xs ml-2" onClick={() => handleRemoveAction(idx)}>Remove</button>
                                </div>
                            ))}
                        </div>
                    </div>
                    {/* Add Condition List */}
                    <div className="w-1/2 bg-white  shadow-[0_1px_4px_rgba(0,0,0,.2)] rounded mb-5 mr-2">
                        <p className="bg-[#f6f8f8] p-4 text-base  border-b border-b-[#efeff4]">  {mode === "create" ? "Add" : "Update"} Condition List</p>
                        <div className="py-4 px-2.5">
                            {true && (
                                <div className="w-full">
                                    <label className="block text-xs mb-1.5 text-[#5E5D5D] font-medium">Category Type</label>
                                    <select className="bg-white text-xs border text-[#5E5D5D]  border-[#EAEAEA] h-9 px-3 rounded w-full" name="device" value={condCategoryType} onChange={e => setCondCategoryType(e.target.value)} >
                                        <option value="">SELECT</option>
                                        <option value="CART">Cart</option>
                                        <option value="USER">User</option>
                                        <option value="CATEGORY">Category</option>
                                        <option value="BRAND">Brand</option>
                                        <option value="PRODUCT">Product</option>
                                        <option value="PAYMENT">Payment</option>
                                    </select>
                                    {condCategoryType === "CART" && (
                                        <>
                                            <div className="flex mb-2">
                                                <input className="w-1/2 mt-2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light mr-2" value='MIN_CART_VALUE' onChange={e => setCondAttributeType('MIN_CART_VALUE')} placeholder="Attribute Type (e.g. MIN_CART_VALUE)" readOnly />
                                                <input className="w-1/2 mt-2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light" ref = {CART_REF} placeholder="Attribute Value (e.g. 500)" />
                                            </div>
                                            <button type="button" className="bg-blue-500 text-white px-4 rounded h-8 mt-2" onClick={()=>{handleAddCondAttribute('MIN_CART_VALUE',CART_REF?.current?.value || '');}}>Add </button>
                                        </>
                                    )}
                                    {condCategoryType === "USER" && (
                                        <>
                                            <div className="flex mb-2">
                                                <input className="w-1/2 mt-2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light mr-2" value='USER_ID' onChange={e => setCondAttributeType('USER_ID')} placeholder="Attribute Type (e.g. MIN_CART_VALUE)" readOnly />
                                                <input className="w-1/2 mt-2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light" ref = {USER_REF} placeholder="Attribute Value (e.g. 500)" />
                                            </div>
                                            <button type="button" className="bg-blue-500 text-white px-4 rounded h-8 mt-2" onClick={()=>{handleAddCondAttribute('USER_ID',USER_REF?.current?.value || '');}}>Add </button>
                                        </>
                                    )}
                                    {condCategoryType === "PAYMENT" && (
                                        <>
                                            <div className="flex mb-2">
                                                <input className="w-1/2 mt-2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light mr-2" value='PAYMENT_TYPE_ALL_OF' onChange={e => setCondAttributeType('PAYMENT_TYPE')} placeholder="Attribute Type (e.g. MIN_CART_VALUE)" readOnly />
                                                <select className="bg-white mt-2 text-xs border text-[#5E5D5D]  border-[#EAEAEA] h-9 px-3 rounded w-full" name="device" ref={PAYMENT_REF}  >
                                                    <option value="">SELECT</option>
                                                    <option value="PREPAID">PREPAID</option>
                                                    <option value="POSTPAID">POSTPAID</option>
                                                </select>
                                            </div>
                                            <div className="flex mb-2">
                                                <input className="w-1/2 mt-2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light mr-2" value='PAYMENT_TYPE_NONE_OF' onChange={e => setCondAttributeType('PAYMENT_TYPE')} placeholder="Attribute Type (e.g. MIN_CART_VALUE)" readOnly />
                                                <Select isMulti options={[{ value: 'COD', label: 'COD' }, { value: 'EMI', label: 'EMI' }, { value: 'BAJFIN', label: 'BAJFIN' },{ value: 'SNAPMINT', label: 'SNAPMINT' },{ value: 'PARTIAL_PAYMENT', label: 'PARTIAL_PAYMENT' }]} className="bg-white mt-2 text-xs border text-[#5E5D5D]  border-[#EAEAEA]  px-3 rounded w-full" classNamePrefix="react-select" name="device" onChange={(selectedOptions: any) => { PAYMENT_NONE_OF_REF.current = selectedOptions ? selectedOptions.map((opt: any) => opt.value).join(", ") : ""; }} />
                                            </div>
                                            <button type="button" className="bg-blue-500 text-white px-4 rounded h-8 mt-2" onClick={() => {
                                                if (PAYMENT_REF?.current?.value) {
                                                    handleAddCondAttribute('PAYMENT_TYPE', PAYMENT_REF.current.value);
                                                    PAYMENT_REF.current.value = '';
                                                }
                                                if (PAYMENT_NONE_OF_REF?.current) {
                                                    handleAddNoneOfCondAttribute('PAYMENT_TYPE', PAYMENT_NONE_OF_REF.current);
                                                    PAYMENT_NONE_OF_REF.current = '';
                                                }
                                            }}>Add </button>
                                        </>
                                    )}
                                    {condCategoryType === "CATEGORY" && (
                                        <>
                                            <div className="flex mb-2">
                                                <input className="w-1/2 mt-2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light mr-2" value='Category(ALL_OF)' onChange={e => setCondAttributeType('CATEGORY_ID')} placeholder="Attribute Type (e.g. MIN_CART_VALUE)" readOnly />
                                                <Select isMulti options={categories} className="bg-white mt-2 text-xs border text-[#5E5D5D]  border-[#EAEAEA]  px-3 rounded w-full" classNamePrefix="react-select" name="device"  onChange={(selectedOptions: any) => { CATEGORY_ALL_OF_REF.current = selectedOptions ? selectedOptions.map((opt: any) => opt.value).join(", "): "";}} />
                                            </div>
                                            <div className="flex mb-2">
                                                <input className="w-1/2 mt-2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light mr-2" value='Category(NONE_OF)' onChange={e => setCondAttributeType('CATEGORY_ID')} placeholder="Attribute Type (e.g. MIN_CART_VALUE)" readOnly />
                                                <Select isMulti options={categories} className="bg-white mt-2 text-xs border text-[#5E5D5D]  border-[#EAEAEA]  px-3 rounded w-full" classNamePrefix="react-select" name="device"  onChange={(selectedOptions: any) => { CATEGORY_NONE_OF_REF.current = selectedOptions ? selectedOptions.map((opt: any) => opt.value).join(", "): "";}} />
                                            </div>
                                            <button
                                                type="button"
                                                className="bg-blue-500 text-white px-4 rounded h-8 mt-2"
                                                onClick={()=>{
                                                    if (CATEGORY_ALL_OF_REF?.current) {
                                                        handleAddCondAttribute('CATEGORY_ID',CATEGORY_ALL_OF_REF?.current || '');
                                                        CATEGORY_ALL_OF_REF.current = '';
                                                    } ;
                                                    if (CATEGORY_NONE_OF_REF?.current) {
                                                        handleAddNoneOfCondAttribute('CATEGORY_ID',CATEGORY_NONE_OF_REF?.current || '');
                                                        CATEGORY_NONE_OF_REF.current = '';
                                                        }
                                                    }}>
                                                Add
                                            </button>
                                        </>
                                    )}
                                    {condCategoryType === "BRAND" && (
                                        <>
                                            <div className="flex mb-2">
                                                <input className="w-1/2 mt-2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light mr-2" value='Brand(All_of)' onChange={e => setCondAttributeType('BRAND_ID')} placeholder="Attribute Type (e.g. MIN_CART_VALUE)" readOnly />
                                                <Select isMulti options={brands} className="bg-white mt-2 text-xs border text-[#5E5D5D]  border-[#EAEAEA]  px-3 rounded w-full" classNamePrefix="react-select" name="device"  onChange={(selectedOptions: any) => { BRAND_ALL_OF_REF.current = selectedOptions ? selectedOptions.map((opt: any) => opt.value).join(", "): "";}} />
                                            </div>
                                            <div className="flex mb-2">
                                                <input className="w-1/2 mt-2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light mr-2" value='Brand(None_of)' onChange={e => setCondAttributeType('BRAND_ID')} placeholder="Attribute Type (e.g. MIN_CART_VALUE)"  readOnly/>
                                                <Select isMulti options={brands} className="bg-white mt-2 text-xs border text-[#5E5D5D]  border-[#EAEAEA]  px-3 rounded w-full" classNamePrefix="react-select" name="device"  onChange={(selectedOptions: any) => { BRAND_NONE_OF_REF.current = selectedOptions ? selectedOptions.map((opt: any) => opt.value).join(", "): "";}} />
                                            </div>
                                            <button
                                            type="button"
                                            className="bg-blue-500 text-white px-4 rounded h-8 mt-2"
                                            onClick={() => {
                                                if (BRAND_ALL_OF_REF?.current) {
                                                    handleAddCondAttribute('BRAND_ID', BRAND_ALL_OF_REF.current || '');
                                                    BRAND_ALL_OF_REF.current = '';
                                                }
                                                if (BRAND_NONE_OF_REF?.current) {
                                                    handleAddNoneOfCondAttribute('BRAND_ID', BRAND_NONE_OF_REF.current || '');
                                                    BRAND_NONE_OF_REF.current = '';
                                                }
                                            }}
                                            >
                                            Add
                                            </button>
                                        </>
                                    )}
                                    {condCategoryType === "PRODUCT" && (
                                        <>
                                            <div className="flex mb-2">
                                                <input className="w-1/2 mt-2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light mr-2" value='Product(All OF)' onChange={e => setCondAttributeType('PRODUCT_ID')} placeholder="Attribute Type (e.g. MIN_CART_VALUE)"readOnly />
                                                <input className="w-1/2 mt-2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light" ref = {PRODUCT_ALL_OF_REF} placeholder="Product MSN Id" />
                                                {/* <button type="button" className="bg-blue-500 text-white px-4 rounded h-8 mt-2" onClick={()=>{handleAddCondAttribute('PRODUCT_ID',PRODUCT_REF?.current?.value || '');}}>Add </button> */}
                                            </div>
                                            <div className="flex mb-2">
                                                <input className="w-1/2 mt-2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light mr-2" value='Product(None OF)' onChange={e => setCondAttributeType('PRODUCT_ID')} placeholder="Attribute Type (e.g. MIN_CART_VALUE)" />
                                                <input className="w-1/2 mt-2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light" ref = {PRODUCT_NONE_OF_REF} placeholder="Product MSN Id" />
                                                {/* <button type="button" className="bg-blue-500 text-white px-4 rounded h-8 mt-2" onClick={()=>{handleAddCondAttribute('PRODUCT_ID',PRODUCT_REF?.current?.value || '');}}>Add </button> */}
                                            </div>
                                            <button
                                                type="button"
                                                className="bg-blue-500 text-white px-4 rounded h-8 mt-2"
                                                onClick={() => {
                                                    if (PRODUCT_ALL_OF_REF?.current?.value) {
                                                        handleAddCondAttribute('PRODUCT_ID', PRODUCT_ALL_OF_REF.current.value || '');
                                                        PRODUCT_ALL_OF_REF.current.value = '';
                                                    }
                                                    if (PRODUCT_NONE_OF_REF?.current?.value) {
                                                        handleAddNoneOfCondAttribute('PRODUCT_ID', PRODUCT_NONE_OF_REF.current.value || '');
                                                        PRODUCT_NONE_OF_REF.current.value = '';
                                                    }
                                                }}
                                                >
                                                Add
                                            </button>
                                        </>
                                    )}
                                </div>
                            )}
                            <div className="px-2 mt-2">

                            {/* ALL_OF group (conditions) */}
                            {conditions.length > 0 && (
                                <>
                                <div className="text-xs font-semibold text-gray-600 mb-1">ALL_OF</div>
                                {conditions.map((cond, idx) => (
                                    <div
                                    key={`allof-${idx}`}
                                    className="flex items-center justify-between bg-gray-100 rounded px-2 py-1 mb-1"
                                    >
                                    <span className="text-xs">
                                        {cond.categoryType}
                                        <div className="mt-1">
                                        {cond.attributeList.map((a: any, i: number) => {
                                            // Check condition and prepare JSX accordingly
                                            if (cond.categoryType === "PAYMENT") {
                                                return (
                                                    <div key={i} className="flex mb-1 gap-2">
                                                    {/* Input for attributeType */}
                                                    <input
                                                        type="text"
                                                        value={a.attributeType}
                                                        className="w-1/2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light"
                                                        readOnly
                                                    />

                                                    {/* Select input for attributeValues */}
                                                    <select
                                                        className="bg-white text-xs border text-[#5E5D5D] border-[#EAEAEA] h-9 px-3 rounded w-full"
                                                        name="device"
                                                        value={a.attributeValues}
                                                        onChange={(e) => {
                                                        const updated = [...conditions];
                                                        updated[idx].attributeList[i].attributeValues = e.target.value
                                                            .split(",")
                                                            .map((v) => v.trim());
                                                        setConditions(updated);
                                                        }}                                                    >
                                                        <option value="true">TRUE</option>
                                                        <option value="false">FALSE</option>
                                                    </select>
                                                    </div>
                                                );
                                            }
                                            else {
                                                return (
                                                    <div key={i} className="flex mb-1 gap-2">
                                                    {/* Input for attributeType */}
                                                    <input
                                                        type="text"
                                                        value={a.attributeType}
                                                        className="w-1/2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light"
                                                        readOnly
                                                    />

                                                    {/* Text input for attributeValues */}
                                                    <input
                                                        type="text"
                                                        value={a.attributeValues.join(",")}
                                                        onChange={(e) => {
                                                        const updated = [...conditions];
                                                        updated[idx].attributeList[i].attributeValues = e.target.value
                                                            .split(",")
                                                            .map((v) => v.trim());
                                                        setConditions(updated);
                                                        }}
                                                        className="w-1/2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light"
                                                    />
                                                    </div>
                                                );
                                            }
                                        })}
                                        </div>
                                    </span>

                                        <button
                                            type="button"
                                            className="text-red-500 text-xs ml-2"
                                            onClick={() => handleRemoveAllOfCondition(idx)}
                                        >
                                        Remove
                                    </button>
                                    </div>
                                ))}
                                </>
                            )}

                            {/* NONE_OF group (noneOfConditions) */}
                            {noneOfConditions.length > 0 && (
                                <>
                                <div className="text-xs font-semibold text-gray-600 mb-1 mt-2">NONE_OF</div>
                                {noneOfConditions.map((cond, idx) => (
                                    <div
                                    key={`noneof-${idx}`}
                                    className="flex items-center justify-between bg-gray-100 rounded px-2 py-1 mb-1"
                                    >
                                    <span className="text-xs">
                                        {cond.categoryType}
                                        <div className="mt-1">
                                            {cond.attributeList.map((a: any, i: number) => (
                                            <div key={i} className="flex mb-1 gap-2">
                                                {/* Input for attributeType */}
                                                <input
                                                    type="text"
                                                    value={a.attributeType}
                                                    className="w-1/2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light"
                                                    readOnly
                                                />

                                                {/* Input for attributeValues (comma separated) */}
                                                <input
                                                    type="text"
                                                    value={a.attributeValues.join(",")}
                                                    onChange={(e) => {
                                                        const updated = [...noneOfConditions];
                                                        updated[idx].attributeList[i].attributeValues = e.target.value
                                                        .split(",")
                                                        .map((v) => v.trim());
                                                        setNoneOfConditions(updated);
                                                    }}
                                                    className="w-1/2 h-8 rounded border text-[#555] border-[#EAEAEA] px-2.5 outline-none text-xs font-light"
                                                />
                                            </div>
                                            ))}
                                        </div>
                                    </span>
                                    <button
                                        type="button"
                                        className="text-red-500 text-xs ml-2"
                                        onClick={() => handleRemoveNoneOfCondition(idx)}
                                    >
                                        Remove
                                    </button>
                                    </div>
                                ))}
                                </>
                            )}
                            </div>

                        </div>
                    </div>
                </div>
                {/* Error and Success Messages */}
                <button type="submit" onClick={handleSubmit} disabled={loading} className="bg-blue-500 text-white px-8 rounded h-9 mt-2 disabled:opacity-50">
                    {loading ? (mode === "update" ? "Updating..." : "Creating...") : (mode === "update" ? "Update Coupon" : "Create Coupon")}
                </button>
                {errors.conditions && <div className="mb-5 text-xs mt-2 text-red-500 mb-2">{errors.conditions}</div>}
                {errors.actions && <div className="mb-5 text-xs mt-2 text-red-500 mb-2">{errors.actions}</div>}
                {apiError && <div className="mb-5 text-xs mt-2 text-red-500 mb-2">{apiError}</div>}
                {/* {success && <div className="text-xs mt-2 text-green-600 mb-2">{success}</div>} */}
            </div>
        </>
    )
}
export default PromoCodeListForm;